
      import { mountFigsNav } from '/src/figs-nav/figs-nav.js';

      mountFigsNav({
        promo: document.querySelector('[data-fnav-promo]'),
        masthead: document.querySelector('[data-fnav-masthead]'),
        theme: 'dark',
        homeHref: '/',
      });
    